import { useTranslation } from 'react-i18next'
import { useYear } from '../contexts/YearContext'

export default function YearSelector() {
  const { t } = useTranslation('components')
  const { selectedYear, setSelectedYear } = useYear()

  return (
    <div className="flex items-center gap-2">
      <label htmlFor="year-select" className="text-sm font-medium text-gray-700 dark:text-gray-300">
        {t('yearSelector.label')}
      </label>
      <select
        id="year-select"
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value as '2025' | '2026')}
        className="px-3 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-hidden focus:ring-2 focus:ring-primary-500 focus:border-transparent"
      >
        <option value="2025">2025</option>
        <option value="2026">2026</option>
      </select>
    </div>
  )
}
